import TeamMemberForm from './TeamMemberForm'

const Create = () => {
    return (
        <TeamMemberForm
            inPopup={false}
            config={{
                submitSuccessMsg: {
                    header: 'Created',
                    message: 'Team member created successfully',
                },
                submitFailedMsg: {
                    header: 'Failed',
                    message: 'Failed to create team member',
                },
                saveButton: {
                    label: 'Create',
                    savingLabel: 'Creating team member...',
                },
            }}
        />
    )
}

export default Create
